import React, { useMemo, useState } from 'react';
import Form from 'react-bootstrap/Form';
import Table from 'react-bootstrap/Table';

const getRoleLabel = (userType) => (
  String(userType || '').toLowerCase() === 'teamlead' ? 'Team Lead' : 'Recruiter'
);

function RequirementAssignMembers({
  members = [],
  selectedMemberIds = [],
  onSelectionChange,
  loading = false,
}) {
  const [search, setSearch] = useState('');

  const filteredMembers = useMemo(() => {
    const query = search.trim().toLowerCase();
    if (!query) return members;

    return members.filter((member) => {
      const name = String(member.EmployeeName || '').toLowerCase();
      const email = String(member.Email || '').toLowerCase();
      const code = String(member.EmpCode || '').toLowerCase();
      const role = getRoleLabel(member.UserType).toLowerCase();
      return name.includes(query) || email.includes(query) || code.includes(query) || role.includes(query);
    });
  }, [members, search]);

  const toggleMember = (memberId, checked) => {
    const id = String(memberId);
    if (checked) {
      onSelectionChange([...new Set([...selectedMemberIds.map(String), id])]);
      return;
    }
    onSelectionChange(selectedMemberIds.filter((item) => String(item) !== id));
  };

  const selectedRecruiters = members.filter(
    (member) => selectedMemberIds.includes(String(member._id)) && member.UserType === 'User'
  ).length;
  const selectedTeamLeads = members.filter(
    (member) => selectedMemberIds.includes(String(member._id)) && member.UserType === 'TeamLead'
  ).length;

  return (
    <div className="hr-assign-members-panel">
      <div className="hr-section-toolbar">
        <h5 className="mb-0">Assign Members</h5>
        <span className="text-muted">{selectedMemberIds.length} selected</span>
      </div>
      <p className="hr-page-hint mb-2">
        Assign this requirement to recruiters, Team Leads, or both. Assigned members must claim before uploading profiles.
      </p>

      {selectedMemberIds.length > 0 && (
        <p className="hr-page-hint mb-2">
          Selected: {selectedRecruiters} recruiter(s), {selectedTeamLeads} Team Lead(s).
        </p>
      )}

      <Form.Control
        type="search"
        placeholder="Search by name, email, code, or role"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className="mb-3"
      />

      {loading ? (
        <p className="hr-empty-state">Loading members...</p>
      ) : filteredMembers.length === 0 ? (
        <p className="hr-empty-state">No recruiters or Team Leads match your search.</p>
      ) : (
        <div className="table-responsive hr-assign-members-table-wrap">
          <Table striped bordered hover size="sm" className="hr-table mb-0">
            <thead>
              <tr>
                <th>Select</th>
                <th>Employee Name</th>
                <th>Email</th>
                <th>Role</th>
              </tr>
            </thead>
            <tbody>
              {filteredMembers.map((member) => {
                const memberId = String(member._id);
                return (
                  <tr key={memberId}>
                    <td>
                      <Form.Check
                        type="checkbox"
                        checked={selectedMemberIds.includes(memberId)}
                        onChange={(e) => toggleMember(memberId, e.target.checked)}
                      />
                    </td>
                    <td>{member.EmployeeName}</td>
                    <td>{member.Email}</td>
                    <td>{getRoleLabel(member.UserType)}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
      )}
    </div>
  );
}

export default RequirementAssignMembers;
